export const roundToOneDecimal = rating => Math.round(rating * 10) / 10
